import OverlappingImages from "../OverlappingImages";
import DescriptionBlock from "../DescriptionBlock";
import OverlappingImagesType2 from "../OverlappingImagesType2";
import Egipt from '../../images/egipt.svg'
import SriLanka from '../../images/srilanka.png'
import Europe from '../../images/europe.png'
import Dubay from '../../images/dubay.png'
import Cypros from '../../images/cyprus.png'
import Thailand from '../../images/thailand.png'
import Maldives from '../../images/maldiv.png'
import Georgia from '../../images/georgia.png'
import classNames from "../../utils";
import CircularImages from "../TravelGrid";
import Image from '../../images/moldivRight.png'
import Image1 from '../../images/moldivLeft.png'
import Image2 from '../../images/moldivCenter.png'
import ImageSri from '../../images/Rectangle 5.png'
import Image1Sri from '../../images/Rectangle 6.png'
import Image2Sri from '../../images/Rectangle 7 (1).png'
import Image2tal from '../../images/thalcenter.png'
import Image2tal1 from '../../images/thal1.png'
import Imagetal2 from '../../images/thal2.png'
import ImageGeorg1 from '../../images/georgiamec.png'
import ImageGeorg2 from '../../images/georgiapoqr.png'
import ImageDubai1 from '../../images/new.png'
import ImageDubai2 from '../../images/dubay1.png'
import Egypt1 from '../../images/egypt1.png'
import Egypt2 from '../../images/egypt2.png'
import Egypt3 from '../../images/egypt3.png'
import Egypt4 from '../../images/egypt4.png'
import Cypros1 from '../../images/cypros.png'
import Cypros2 from '../../images/cypros1.png'
import Cypros3 from '../../images/cypros2.png'
import Cypros4 from '../../images/cypros3.png'
import Euro1 from '../../images/euro1.png'
import Euro2 from '../../images/euro2.png'
import Euro3 from '../../images/euro3.png'
import Euro4 from '../../images/euro4.png'
import ForImages from "../FourImages";



const destinationsData = [
  {id: 1, type: 4, href: 'Egypt', images: [{url: Egypt1 }, {url : Egypt2 },{ url: Egypt3}, {url: Egypt4 }], title: 'Egypt', color: 'orange', subTitle: 'Discover the Timeless Wonders of', description: 'Explore the ancient and the modern in one unforgettable journey to Egypt with 365 Travelling. From the iconic pyramids of Giza to the vibrant streets of Cairo, Egypt offers a wealth of experiences that cater to every traveler\'s dream', icon: Egipt},
  {id: 2, type: 1, href: 'SriLanka', images: [{url: ImageSri }, {url : Image1Sri },{ url: Image2Sri}],  title: 'SriLanka', color: 'green', subTitle: 'Unveil the Hidden Treasures of', description: 'Embark on an enchanting journey to Sri Lanka with 365 Travelling, where lush landscapes, ancient ruins, and pristine beaches await. From the cultural heartland of Kandy to the wildlife-rich national parks, Sri Lanka offers a diverse array of experiences for every type of traveler.', icon: SriLanka},
  {id: 3, type: 2, href: 'Dubai', images: [{url: ImageDubai1 }, {url : ImageDubai2 }], title: 'Dubai', color: 'pink', subTitle: 'Experience the Extravagance of', description: 'Embark on an unforgettable journey to Dubai with 365 Travelling, where futuristic skyscrapers, luxurious resorts, and timeless desert landscapes await. From the bustling souks and grand malls to the serene beaches and adventurous desert safaris, Dubai offers a myriad of experiences that cater to every traveler’s desires.', icon: Dubay},
  {id: 4, type: 4, href: 'Cyprus', images: [{url: Cypros2 }, {url : Cypros3 },{ url: Cypros4}, {url: Cypros1}], title: 'Cyprus', color: 'blue', subTitle: 'Discover the Enchanting Allure of', description: 'Embark on a captivating journey to Cyprus with 365 Travelling, where ancient history, stunning beaches, and picturesque villages await. From the archaeological wonders of Paphos to the vibrant nightlife of Ayia Napa, Cyprus offers a rich tapestry of experiences for every type of traveler.', icon: Cypros},
  {id: 5, type: 1, href: 'Thailand', images: [{url: Image2tal }, {url : Image2tal1 },{ url: Imagetal2}], title: 'Thailand', color: 'fuchsia', subTitle: 'Explore the Exotic Charms of', description: 'Embark on a mesmerizing journey to Thailand with 365 Travelling, where vibrant cities, ancient temples, and idyllic beaches await. From the bustling streets of Bangkok to the serene islands of Phuket, Thailand offers a diverse array of experiences for every traveler.', icon: Thailand},
  {id: 6, type: 3, href: 'Maldives', images: [{url: Image }, {url : Image1 },{ url: Image2}], title: 'Maldives', color: 'pink', subTitle: 'Escape to the Paradise of the', description: 'Embark on a luxurious journey to the Maldives with 365 Travelling, where crystal-clear waters, white sandy beaches, and stunning overwater villas await. From world-class diving spots to serene spa retreats, the Maldives offers a perfect blend of relaxation and adventure for every traveler.', icon: Maldives},
  {id: 7, type: 2, href: 'Georgia', images: [{url: ImageGeorg1 }, {url : ImageGeorg2 }], title: 'Georgia', color: 'orange', subTitle: 'Uncover the Rich Heritage of', description: 'Embark on a luxurious journey to the Maldives with 365 Travelling, where crystal-clear waters, white sandy beaches, and stunning overwater villas await. From world-class diving spots to serene spa retreats, the Maldives offers a perfect blend of relaxation and adventure for every traveler.', icon: Georgia},
  {id: 8, type: 4, href: 'Europe', images: [{url: Euro1 }, {url : Euro2 },{ url: Euro3}, {url: Euro4}], title: 'EUROPE', color: 'green', subTitle: 'Experience the Diverse Wonders of ', description: 'Embark on a luxurious journey to the Maldives with 365 Travelling, where crystal-clear waters, white sandy beaches, and stunning overwater villas await. From world-class diving spots to serene spa retreats, the Maldives offers a perfect blend of relaxation and adventure for every traveler.', icon: Europe}
]

const BlockFore = () => {
  const renderComponent = (type, images) => {
    switch (type) {
      case 1:
        return <OverlappingImages images={images} />;
      case 2:
        return <OverlappingImagesType2 images={images} />;
      case 3:
        return <CircularImages images={images} />;
      case 4:
        return <ForImages images={images} />;
      default:
        return null;
    }
  };

  return (
    <div className="space-y-16">
      {destinationsData.map((item,index) => {
        return (
          <div id={item.href} key={item.id} className={classNames('px-6 w-full flex flex-col lg:flex-row justify-center gap-x-14 items-center space-y-6',  index % 2 === 1 && 'flex-row-reverse lg:flex-row-reverse')}>
            <DescriptionBlock
              icon={item.icon}
              description={item.description}
              title={item.title}
              subTitle={item.subTitle}
              type={item.type}
              color={item.color}
            />
            {renderComponent(item.type, item.images)}
          </div>
        )
      })}
    </div>
  )
}

export default BlockFore